import { render, staticRenderFns } from "./takeout.vue?vue&type=template&id=4faea174&scoped=true&"
import script from "./takeout.vue?vue&type=script&lang=js&"
export * from "./takeout.vue?vue&type=script&lang=js&"
import style0 from "./takeout.vue?vue&type=style&index=0&id=4faea174&scoped=true&lang=css&"
import style1 from "./takeout.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faea174",
  null
  
)

export default component.exports